

import React, { memo } from 'react';
import Icon from '../../Icon';

import {
  EXPANDER_DEFAULT_COLOR,
  EXPANDER_DEFAULT_ICON,
  EXPANDER_DEFAULT_ICON_SIZE } from
'../../../../common/constants/expanderIconDefaultProps';
import '../styles/_expander-icon.scss';





const ExpanderIcon = (props) => {
  const {
    isExpanded,
    size = EXPANDER_DEFAULT_ICON_SIZE,
    color = EXPANDER_DEFAULT_COLOR.STATIC,
    hoverColor = EXPANDER_DEFAULT_COLOR.HOVER,
    ...iconProps
  } = props;

  const name = isExpanded ? EXPANDER_DEFAULT_ICON.EXPANDED : EXPANDER_DEFAULT_ICON.COLLAPSED;

  return (
    <Icon
      {...iconProps}
      className="expander-icon"
      name={name}
      size={size}
      color={color}
      hoverColor={hoverColor} />);


};

export default memo(ExpanderIcon);